import { render, staticRenderFns } from "./SGUserSummary.vue?vue&type=template&id=753267c4"
import script from "./SGUserSummary.vue?vue&type=script&lang=js"
export * from "./SGUserSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports